// DAC Sample Tracker (51_PartnerSamples.jsx) — the strings it still wrote in English, in the portal's four languages
// (2026-10-21). The rest of the screen reads `st.`, `ps.` and `tour.` from i18n.js. The Excel headings are an
// export to read (nothing imports that file back), so they follow the reader's language too.
const en = {
  close: 'Close',
  auto: '(auto)',
  requestFailed: 'Request failed ({{status}})',
  ofTotal: '{{label}} - of {{total}} total',
  cancelledAdvance: 'Cancelled - {{id}} was NOT set to Advance and no new round was created',
  cancelledAdvanceRound: 'Cancelled - the round was NOT set to Advance and no new round was created',
  developerRequired: 'Developer is required',
  photoRequired: 'A new Base ID needs at least one photo of the sample',
  advanced: '{{from}} set to Advance and {{to}} created',
  roundUpdated: 'Round updated',
  round: 'Round',
  roundAdded: '{{id}} added',
  roundAddedPhotos: '{{id}} added — {{n}} photo(s) attached to {{base}}',
  theBaseId: 'the Base ID',
  confirmDelete: 'Delete round {{id}}? This cannot be undone.',
  roundDeleted: 'Round deleted',
  renamed: '{{id}} renamed to "{{name}}" ({{n}} round(s))',
  noRowsToExport: 'No rows to export',
  noneSelected: 'None selected',
  allSamples: 'All Samples',
  allRounds: 'All Rounds',
  allDevelopers: 'All Developers',
  allLocations: 'All Locations',
  filterSample: 'Sample: {{v}}',
  filterRound: 'Round: {{v}}',
  filterDeveloper: 'Developer: {{v}}',
  filterLocation: 'Location: {{v}}',
  filterSearch: 'Search: {{v}}',
  preparingExport: 'Preparing Excel export...',
  exportTitle: '{{org}} - All Samples',
  exportFailedStatus: 'Export failed ({{status}})',
  exportFailed: 'Export failed',
  excelExported: 'Excel exported',
  editRound: 'Edit round',
  duplicateRound: 'Duplicate round',
  deleteRound: 'Delete round',
  addRound: 'Add round',
  editBase: 'Edit Base ID (photos, style name)',
  noRounds: 'No rounds to display',
  noData: 'No data to display',
  searchSample: 'Search sample...',
  backToBase: 'Back to Base ID view',
  col: {
    baseId: 'Base ID', styleItem: 'Style / Item', round: 'Round', season: 'Season', location: 'Location',
    developer: 'Developer', requestDate: 'Request Date', developmentDue: 'Development Due', rmReady: 'RM Ready',
    sampleFinish: 'Sample Finish', comment: 'Comment', qty: 'QTY', rounds: 'Rounds', status: 'Status',
    dDay: 'D-day', daysWaiting: 'Days Waiting', remarks: 'Remarks',
  },
};

const ko = {
  close: '닫기',
  auto: '(자동)',
  requestFailed: '요청 실패 ({{status}})',
  ofTotal: '{{label}} - 전체 {{total}} 중',
  cancelledAdvance: '취소됨 - {{id}}은(는) Advance로 설정되지 않았고 새 라운드도 만들어지지 않았습니다',
  cancelledAdvanceRound: '취소됨 - 라운드가 Advance로 설정되지 않았고 새 라운드도 만들어지지 않았습니다',
  developerRequired: '개발자를 입력하세요',
  photoRequired: '새 Base ID에는 샘플 사진이 한 장 이상 필요합니다',
  advanced: '{{from}}을(를) Advance로 설정하고 {{to}}을(를) 만들었습니다',
  roundUpdated: '라운드를 수정했습니다',
  round: '라운드',
  roundAdded: '{{id}} 추가됨',
  roundAddedPhotos: '{{id}} 추가됨 — 사진 {{n}}장을 {{base}}에 첨부했습니다',
  theBaseId: 'Base ID',
  confirmDelete: '라운드 {{id}}을(를) 삭제할까요? 되돌릴 수 없습니다.',
  roundDeleted: '라운드를 삭제했습니다',
  renamed: '{{id}}의 이름을 "{{name}}"(으)로 바꿨습니다 (라운드 {{n}}개)',
  noRowsToExport: '내보낼 행이 없습니다',
  noneSelected: '선택 없음',
  allSamples: '전체 샘플',
  allRounds: '전체 라운드',
  allDevelopers: '전체 개발자',
  allLocations: '모든 위치',
  filterSample: '샘플: {{v}}',
  filterRound: '라운드: {{v}}',
  filterDeveloper: '개발자: {{v}}',
  filterLocation: '위치: {{v}}',
  filterSearch: '검색: {{v}}',
  preparingExport: '엑셀 내보내기 준비 중...',
  exportTitle: '{{org}} - 전체 샘플',
  exportFailedStatus: '내보내기 실패 ({{status}})',
  exportFailed: '내보내기 실패',
  excelExported: '엑셀을 내보냈습니다',
  editRound: '라운드 수정',
  duplicateRound: '라운드 복제',
  deleteRound: '라운드 삭제',
  addRound: '라운드 추가',
  editBase: 'Base ID 수정 (사진, 스타일명)',
  noRounds: '표시할 라운드가 없습니다',
  noData: '표시할 데이터가 없습니다',
  searchSample: '샘플 검색...',
  backToBase: 'Base ID 보기로 돌아가기',
  col: {
    baseId: 'Base ID', styleItem: '스타일 / 품목', round: '라운드', season: '시즌', location: '위치',
    developer: '개발자', requestDate: '요청일', developmentDue: '개발 기한', rmReady: '원자재 준비',
    sampleFinish: '샘플 완료일', comment: '코멘트일', qty: '수량', rounds: '라운드 수', status: '상태',
    dDay: 'D-day', daysWaiting: '대기 일수', remarks: '비고',
  },
};

const vi = {
  close: 'Đóng',
  auto: '(tự động)',
  requestFailed: 'Yêu cầu thất bại ({{status}})',
  ofTotal: '{{label}} - trên tổng {{total}}',
  cancelledAdvance: 'Đã hủy - {{id}} KHÔNG được chuyển sang Advance và không tạo vòng mới',
  cancelledAdvanceRound: 'Đã hủy - vòng này KHÔNG được chuyển sang Advance và không tạo vòng mới',
  developerRequired: 'Cần chọn Developer',
  photoRequired: 'Base ID mới cần ít nhất một ảnh của mẫu',
  advanced: 'Đã chuyển {{from}} sang Advance và tạo {{to}}',
  roundUpdated: 'Đã cập nhật vòng',
  round: 'Vòng',
  roundAdded: 'Đã thêm {{id}}',
  roundAddedPhotos: 'Đã thêm {{id}} — {{n}} ảnh đã đính kèm vào {{base}}',
  theBaseId: 'Base ID',
  confirmDelete: 'Xóa vòng {{id}}? Không thể hoàn tác.',
  roundDeleted: 'Đã xóa vòng',
  renamed: 'Đã đổi tên {{id}} thành "{{name}}" ({{n}} vòng)',
  noRowsToExport: 'Không có dòng nào để xuất',
  noneSelected: 'Không chọn gì',
  allSamples: 'Tất cả mẫu',
  allRounds: 'Tất cả vòng',
  allDevelopers: 'Tất cả Developer',
  allLocations: 'Tất cả địa điểm',
  filterSample: 'Mẫu: {{v}}',
  filterRound: 'Vòng: {{v}}',
  filterDeveloper: 'Developer: {{v}}',
  filterLocation: 'Địa điểm: {{v}}',
  filterSearch: 'Tìm kiếm: {{v}}',
  preparingExport: 'Đang chuẩn bị xuất Excel...',
  exportTitle: '{{org}} - Tất cả mẫu',
  exportFailedStatus: 'Xuất thất bại ({{status}})',
  exportFailed: 'Xuất thất bại',
  excelExported: 'Đã xuất Excel',
  editRound: 'Sửa vòng',
  duplicateRound: 'Nhân bản vòng',
  deleteRound: 'Xóa vòng',
  addRound: 'Thêm vòng',
  editBase: 'Sửa Base ID (ảnh, tên style)',
  noRounds: 'Không có vòng nào để hiển thị',
  noData: 'Không có dữ liệu để hiển thị',
  searchSample: 'Tìm mẫu...',
  backToBase: 'Quay lại xem theo Base ID',
  col: {
    baseId: 'Base ID', styleItem: 'Style / Mặt hàng', round: 'Vòng', season: 'Mùa', location: 'Địa điểm',
    developer: 'Developer', requestDate: 'Ngày yêu cầu', developmentDue: 'Hạn phát triển', rmReady: 'RM sẵn sàng',
    sampleFinish: 'Ngày hoàn thành mẫu', comment: 'Ngày nhận xét', qty: 'SL', rounds: 'Số vòng', status: 'Trạng thái',
    dDay: 'D-day', daysWaiting: 'Số ngày chờ', remarks: 'Ghi chú',
  },
};

const zh = {
  close: '关闭',
  auto: '（自动）',
  requestFailed: '请求失败（{{status}}）',
  ofTotal: '{{label}} - 共 {{total}}',
  cancelledAdvance: '已取消 - {{id}} 未设为 Advance，也未创建新轮次',
  cancelledAdvanceRound: '已取消 - 该轮次未设为 Advance，也未创建新轮次',
  developerRequired: '请填写开发员',
  photoRequired: '新的 Base ID 至少需要一张样品照片',
  advanced: '{{from}} 已设为 Advance，并创建了 {{to}}',
  roundUpdated: '轮次已更新',
  round: '轮次',
  roundAdded: '已添加 {{id}}',
  roundAddedPhotos: '已添加 {{id}} — {{n}} 张照片已附加到 {{base}}',
  theBaseId: 'Base ID',
  confirmDelete: '删除轮次 {{id}}？此操作无法撤销。',
  roundDeleted: '轮次已删除',
  renamed: '{{id}} 已重命名为“{{name}}”（{{n}} 个轮次）',
  noRowsToExport: '没有可导出的行',
  noneSelected: '未选择',
  allSamples: '全部样品',
  allRounds: '全部轮次',
  allDevelopers: '全部开发员',
  allLocations: '全部地点',
  filterSample: '样品：{{v}}',
  filterRound: '轮次：{{v}}',
  filterDeveloper: '开发员：{{v}}',
  filterLocation: '地点：{{v}}',
  filterSearch: '搜索：{{v}}',
  preparingExport: '正在准备导出 Excel...',
  exportTitle: '{{org}} - 全部样品',
  exportFailedStatus: '导出失败（{{status}}）',
  exportFailed: '导出失败',
  excelExported: 'Excel 已导出',
  editRound: '编辑轮次',
  duplicateRound: '复制轮次',
  deleteRound: '删除轮次',
  addRound: '添加轮次',
  editBase: '编辑 Base ID（照片、款式名称）',
  noRounds: '没有可显示的轮次',
  noData: '没有可显示的数据',
  searchSample: '搜索样品...',
  backToBase: '返回 Base ID 视图',
  col: {
    baseId: 'Base ID', styleItem: '款式 / 品项', round: '轮次', season: '季', location: '地点',
    developer: '开发员', requestDate: '申请日期', developmentDue: '开发截止日', rmReady: 'RM 就绪',
    sampleFinish: '样品完成日期', comment: '意见日期', qty: '数量', rounds: '轮次数', status: '状态',
    dDay: 'D-day', daysWaiting: '等待天数', remarks: '备注',
  },
};

const dictionary = { ns: 'xPartner', en, ko, vi, zh };

export default dictionary;
